<template>
  <div class="purification">

    <div class="timing" v-if="modeArray&&modeArray.length>0">
      <div v-for="model in modeArray" class="purification-mode">
        <div class="title">{{ model.name }}</div>
        <div class="action">
          <div class="clickable" v-for="(option,index) in options" v-bind:class="{'action-selected': getValue(model.dataId)==option.value}"
               @click="$emit('control',model.dataId,index)">● {{ option.name }}</div>
        </div>
        <div v-if="model.time">
          <div class="time-row clickable" @click="clickTimeOn(model)">开始 {{getValue(model.time.onDataId)}} 分钟</div>
          <div class="time-row clickable" @click="clickTimeOff(model)">停止 {{getValue(model.time.offDataId)}} 分钟</div>
        </div>

      </div>
    </div>

    <InputDialog ref="inputDialog"></InputDialog>

  </div>
</template>

<script>
import InputDialog from "@/components/dialog/InputDialog";
import RowItem from "@/views/device/_components/RowItem.vue";
export default {
  components: {InputDialog},
  props: ["modeArray","valueMap"],
  methods:{
    getValue(key){
      return this.valueMap[key]
    },
    control(key,value){
      this.$emit("control",key,value)
    },
    clickTimeOn(model){
      let that = this
      this.$refs.inputDialog.show({
        title: "设定启动时间",
        value: that.getValue(model.time.onDataId),
        onOk(value) {
          let dataId = model.time.onDataId
          that.control(dataId, value)
        }
      })
    },
    clickTimeOff(model){
      let that = this
      this.$refs.inputDialog.show({
        title: "设定停止时间",
        value: that.getValue(model.time.offDataId),
        onOk(value) {
          let dataId = model.time.offDataId
          that.control(dataId, value)
        }
      })
    }
  },
  computed:{
    options(){
      if(this.modeArray[0].time){
        return [
          {
            name: "自动",
            value: 0
          },
          {
            name: "间断",
            value: 1
          },
          {
            name: "定时",
            value: 2
          },
          {
            name: "手动",
            value: 3
          }
        ]
      }else{
        return [
          {
            name: "自动",
            value: 0
          },
          {
            name: "手动",
            value: 1
          }
        ]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.purification {

  .timing{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2vw;
  }

  .purification-mode {
    align-items: center;
    background: #03417B;
    border-radius: 10px;
    overflow: hidden;

    .title {
      text-align: center;
      background: #063366;
      font-size: 1.2vw;
      padding: 0.2vw;
    }
    .action{
      display: grid;
      grid-template-columns: repeat(2,1fr);
      text-align: center;
      font-size: 1.2vw;
      grid-column-gap: 2vw;
      grid-row-gap: 1vw;
      padding: 1vw;
    }

    .action-selected{
      color: #0084FF;
    }

    .time-row{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1vw;
      background: #063366;
      margin: 5px;
      padding: 10px;
      border-radius: 10px;
    }
  }

}
</style>
